import { gql } from '@apollo/client';

export const qualityReturnReceiptsQuery = gql`
  query (
    $personId: Int!
    $initialRow: Int!
    $nextRows: Int!
    $productDivisionIndicator: ProductDivisionIndicator
    $productGroupId: Int
    $productId: Int
    $receiptDate: String
  ) {
    qualityReturnReceipts(
      personId: $personId
      initialRow: $initialRow
      nextRows: $nextRows
      productDivisionIndicator: $productDivisionIndicator
      productGroupId: $productGroupId
      productId: $productId
      receiptDate: $receiptDate
    ) {
      returnReceiptId
      personId
      productId
      productName
      productDivisionId
      productDivisionName
      productGroupId
      productGroupName
      receiptDate
      scheduledQuantity
      inspectedQuantity
      returnedQuantity
      stokedQuantity
      returnReceiptReasons {
        reasonCode
        reasonDescription
      }
      noteDescription
      totalRows
    }
  }
`;
